import { notification } from 'antd';
import { helpers, config, types } from '.';

let loggingOut = false;

export const FORBIDDEN_MESSAGE = 'Feature not available via this route. Contact support team at cs-cx@ogateway.co, or via support channels';

export const signOutSuccess = async (path = '/') => {
    if (!loggingOut) {
        loggingOut = true;
        notification.success({ message: 'Session ended' });
        helpers.delStorage('auth');
        // helpers.delStorage('utils');
        helpers.delStorage('login');
        helpers.delStorage('defaultPassword');
        setTimeout(() => {
            helpers.redirect(path);
        }, 200);
    }
};


export const apnData = (obj: any) => {
    const body = new FormData();
    for (const p in obj) {
        body.append(p, obj[p]);
    }
    return body;
}

export const apiHeaders = (type = ''): any => {
    const business: types.Business = helpers.isJson(helpers.getStorageJson('auth').business) ? JSON.parse(helpers.getStorageJson('auth').business) : {};
    switch (type) {
        default:
            return {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-ogateway-token': helpers.md5({ businessId: business.id }),
            };

        case 'file':
            return {
                'Accept': 'application/json',
                'x-ogateway-token': helpers.md5({ businessId: business.id }),
            };
    }
}

const axiosURL = (action: string) => {
    const env = helpers.isJson(helpers.getStorageJson('utils').env) ? JSON.parse(helpers.getStorageJson('utils').env) : '';
    const empty = action.includes('http:') || action.includes('https:') ? true : false;
    const url = ((empty === false) ? (env === 'live' ? config.server : config.server) + action : action);
    return url;
}

export const get = async (action: string, data = {}) => {
    const stage = helpers.isJson(helpers.getStorageJson('utils').env) ? JSON.parse(helpers.getStorageJson('utils').env) : '';
    const headers = apiHeaders();
    try {
        const response = await fetch(axiosURL(action) + '?' + new URLSearchParams({ ...data, stage }).toString(), {
            method: 'GET',
            headers,
            credentials: 'include',
        });
        return await respunse(response);
    } catch (error: any) {
        if (error.message === 'Failed to fetch') {
            // signOutSuccess();
        }
        return { status: 606, message: 'Network request failed', data: error };
    }
}

export const post = async (action: string, data: any = {}) => {
    const stage = helpers.isJson(helpers.getStorageJson('utils').env) ? JSON.parse(helpers.getStorageJson('utils').env) : '';
    const headers = apiHeaders();
    try {
        const response = await fetch(axiosURL(action), {
            method: 'POST',
            headers,
            credentials: 'include',
            body: JSON.stringify({ ...data, stage }),
        });
        return await respunse(response);
    } catch (error) {
        return { status: 606, message: 'Network request failed', data: error };
    }
}

export const put = async (action: string, data = {}) => {
    const headers = apiHeaders();
    try {
        const response = await fetch(axiosURL(action), {
            method: 'PUT',
            headers,
            credentials: 'include',
            body: JSON.stringify(data),
        });
        return await respunse(response);
    } catch (error) {
        return { status: 606, message: 'Network request failed', data: error };
    }
}

export const patch = async (action: string, data = {}) => {
    const headers = apiHeaders();
    try {
        const response = await fetch(axiosURL(action), {
            method: 'PATCH',
            headers,
            credentials: 'include',
            body: JSON.stringify(data),
        });
        return await respunse(response);
    } catch (error) {
        return { status: 606, message: 'Network request failed', data: error };
    }
}

export const delte = async (action: string, data: any = {}) => {
    const headers = apiHeaders();
    try {
        const response = await fetch(axiosURL(action), {
            method: 'DELETE',
            headers,
            credentials: 'include',
            body: JSON.stringify(data),
        });
        return await respunse(response);
    } catch (error) {
        return { status: 606, message: 'Network request failed', data: error };
    }
}

export const postFile = async (action: string, data: any = {}) => {
    const headers = apiHeaders('file');
    try {
        const response = await fetch(axiosURL(action), {
            method: 'POST',
            headers,
            credentials: 'include',
            body: apnData(data),
        });
        return await respunse(response);
    } catch (error) {
        return { status: 606, message: 'Network request failed', data: error };
    }
}

const respunse = async (response: Response) => {
    const res = await response.json();
    const status = response.status;
    if (status === 401) {
        signOutSuccess('/auth/login');
    }
    if (status === 403) {
        return { data: res, status, message: FORBIDDEN_MESSAGE };
    }
    const message = Array.isArray(res) && ![201, 200].includes(status) ? res.join("\n\n") : (res.message || '');
    return { data: res, status, message };
}